import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ef4b7a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lp-card playlist"
}
const _hoisted_2 = { class: "playlist__head" }
const _hoisted_3 = { class: "playlist__progress" }
const _hoisted_4 = { class: "lp-bar" }
const _hoisted_5 = { class: "playlist__list" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "playlist__state" }
const _hoisted_8 = { class: "playlist__text" }
const _hoisted_9 = { class: "playlist__title" }
const _hoisted_10 = { class: "playlist__meta" }
const _hoisted_11 = { class: "playlist__state" }
const _hoisted_12 = { class: "playlist__text" }
const _hoisted_13 = { class: "playlist__title" }
const _hoisted_14 = { class: "playlist__meta" }
const _hoisted_15 = { class: "playlist__footer" }

import { computed } from 'vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import {
  ISection,
  IResources,
  PLANS_URL,
  hasAccess,
  resourceHref,
  resourceKind,
  resourceLevel,
  resourceTitle,
  sectionProgress,
  useLearningPathI18n,
} from '../view/learningPath';


export default /*#__PURE__*/_defineComponent({
  props: {
    sections: null,
    currentSectionIndex: null,
    currentResourceId: null,
    pathwayId: null,
    pathwayHref: null
  },
  setup(__props: any) {

const props = __props as {
  sections: ISection[]
  currentSectionIndex: number
  currentResourceId: number | null
  pathwayId: string
  pathwayHref: string
}



const { tl } = useLearningPathI18n();

const KIND_ICON = { lesson: 'video', challenge: 'flag', machine: 'display' };

const section = computed(() => props.sections[props.currentSectionIndex] ?? null);
const progress = computed(() => section.value ? sectionProgress(section.value) : { done: 0, total: 0 });
const percent = computed(() => progress.value.total ? (progress.value.done / progress.value.total) * 100 : 0);
const nextSection = computed(() => props.sections[props.currentSectionIndex + 1] ?? null);
const nextSectionProgress = computed(() => nextSection.value ? sectionProgress(nextSection.value) : null);

const meta = (resource: IResources) => {
  const kind = resourceKind(resource);
  const parts = [tl(`type_${kind}`)];
  const level = resourceLevel(resource);
  if (level) parts.push(tl(`level_${level}`));
  if (!hasAccess(resource)) parts.push(tl('subscribers'));
  return parts.join(' · ');
};

const hrefFor = (resource: IResources) => resourceHref(props.pathwayId, resource) || props.pathwayHref;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(section))
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("small", null, _toDisplayString(_unref(tl)('section_of', { current: __props.currentSectionIndex + 1, total: __props.sections.length })), 1),
          _createElementVNode("h3", null, _toDisplayString(_unref(section).title), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("span", {
                style: _normalizeStyle({ width: `${_unref(percent)}%` })
              }, null, 4)
            ]),
            _createElementVNode("span", null, _toDisplayString(_unref(tl)('completed_count', { done: _unref(progress).done, total: _unref(progress).total })), 1)
          ])
        ]),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(section).resources, (resource) => {
            return (_openBlock(), _createElementBlock("li", {
              key: resource.id
            }, [
              (!_unref(hasAccess)(resource))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _unref(PLANS_URL),
                    target: "_blank",
                    class: "playlist__item playlist__item--locked"
                  }, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(HcIcon, {
                        name: "lock",
                        size: 15
                      })
                    ]),
                    _createElementVNode("span", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(resourceTitle)(resource)), 1),
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(HcIcon, {
                          name: KIND_ICON[_unref(resourceKind)(resource)],
                          size: 13
                        }, null, 8, ["name"]),
                        _createTextVNode(_toDisplayString(meta(resource)), 1)
                      ])
                    ])
                  ], 8, _hoisted_6))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: hrefFor(resource),
                    class: _normalizeClass(["playlist__item", {
            'playlist__item--done': resource.completed,
            'playlist__item--current': resource.id === __props.currentResourceId,
          }])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_11, [
                        (resource.completed)
                          ? (_openBlock(), _createBlock(HcIcon, {
                              key: 0,
                              name: "check",
                              size: 12
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(resourceTitle)(resource)), 1),
                        _createElementVNode("span", _hoisted_14, [
                          _createVNode(HcIcon, {
                            name: KIND_ICON[_unref(resourceKind)(resource)],
                            size: 13
                          }, null, 8, ["name"]),
                          _createTextVNode(_toDisplayString(meta(resource)), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_unref(nextSection))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: __props.pathwayHref,
                class: "playlist__link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(tl)('section_label')) + " " + _toDisplayString(__props.currentSectionIndex + 2) + " — " + _toDisplayString(_unref(nextSection).title), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(nextSectionProgress)?.done) + "/" + _toDisplayString(_unref(nextSectionProgress)?.total), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: __props.pathwayHref,
            class: "playlist__link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(tl)('all_sections')), 1),
              _createVNode(HcIcon, {
                name: "chevron-right",
                size: 14
              })
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})